import DefaultLayout from "@/components/DefaultLayout"
import Head from "next/head"
import styles from "@/styles/trackorder.module.scss"
import { Button, Col, Form, Input, message, Row, Table } from "antd"
import Image from "next/image"
import Link from "next/link"
import orderApi from "@/service/modules/orderApi"
import { useState } from "react"
import WishlistEmpty from '@/svgs/Wishlist-empty.svg'
export default function Trackorder() {

  const [loading, setLoading] = useState<boolean>(false)
  const [summary, setSummary] = useState<any>({})
  const [list, setList] = useState<any>([])

  const onFinish = (values: any) => {
    getList(values)
  };

  const getList = async (params: any) => {
    setLoading(true)
    try {
      const res = await orderApi.trackOrder(params)
      const { order: { items }, order } = res.data
      setList(items)
      setSummary(order)
      setLoading(false)

    } catch (error: any) {
      message.error(error.message)
      setLoading(false)
    }
  }

  return (
    <>
      <Head>
        <title>{`Track My Order - BestDeals.co.nz`}</title>
      </Head>
      <DefaultLayout >
        <div className={styles.trackorder}>
          <div className={styles.title}>Track My Order</div>
          <div className={styles.main}>
            <div className={styles.filterBox}>
              <div className={styles.filterTitle}>Enter your order number and email address below for fast and secure tracking of your order</div>
              <div className={styles.filterForm}>
                <Form
                  name="basic"
                  layout="vertical"
                  onFinish={onFinish}
                  autoComplete="off"
                >
                  <Row gutter={16}>
                    <Col span={9}>
                      <Form.Item
                        label="Order Number"
                        name="orderID"
                        rules={[
                          { required: true, message: 'The order number is required.' }
                        ]}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={9}>
                      <Form.Item
                        label="Email"
                        name="email"
                        validateTrigger="onBlur"
                        rules={[
                          { required: true, message: 'The email is required.' },
                          // { type: 'email', message: 'The email is invalid.' },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item label={null}>
                        <Button className={styles.submitBTn} htmlType="submit" loading={loading} style={{ marginTop: 30 }}>
                          Track
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </div>

              <div className={styles.summary}>
                <div className={styles.summaryTitle}>Order Tracking Summary</div>
                <Row gutter={16}>
                  <Col span={9}>
                    <div className={styles.summaryItem}>
                      <div className={styles.summaryItemTitle}>Order Number:</div>
                      <div className={styles.summaryItemContent}>{summary.orderID}</div>
                    </div>
                    <div className={styles.summaryItem}>
                      <div className={styles.summaryItemTitle}>Order Placed:</div>
                      <div className={styles.summaryItemContent}>{summary.orderTime}</div>
                    </div>
                  </Col>
                  <Col span={9}>
                    <div className={styles.summaryItem}>
                      <div className={styles.summaryItemTitle}>Order Status:</div>
                      <div className={styles.summaryItemContent} style={{ color: '#E7415F' }}>{summary.statusName}</div>
                    </div>
                    <div className={styles.summaryItem}>
                      <div className={styles.summaryItemTitle}>Approval Date:</div>
                      <div className={styles.summaryItemContent}>{summary.sendDate}</div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>

            {
              list.length > 0
              &&
              <div className={styles.orderList}>

                <>
                  <div className={styles.tableHead}>
                    <div className={`${styles.tableHeadItem} ${styles.goodsItem}`}>ltem</div>
                    <div className={styles.tableHeadItem}>Quantity</div>
                    <div className={styles.tableHeadItem}>Carrier</div>
                    <div className={styles.tableHeadItem}>Tracking Number</div>
                  </div>

                  <div className={styles.tableBody}>

                    {
                      list.map((item: any) => (
                        <div className={styles.tableRow} key={item.productID}>
                          <div className={`${styles.tableRowItem} ${styles.goodsItem}`}>
                            <div className={styles.goodsInfo}>
                              <div className={styles.goodsImg}>
                                <Image src={item.thumbnail} width={96} height={96} alt={item.name} />
                              </div>
                              <div className={styles.goodsName}>{item.name}</div>
                            </div>
                          </div>
                          <div className={styles.tableRowItem}>{item.quantity}</div>
                          <div className={styles.tableRowItem}>{item.courierName}</div>
                          <div className={styles.tableRowItem}>
                            {
                              (item.trackSiteUrls && item.trackSiteUrls.length > 0)
                                ?
                                item.trackSiteUrls.map((trackItem: any, index: number) => (
                                  <div className={styles.trackingItem} key={index}>
                                    <div className={styles.trackingItemTitle}>{trackItem.trackingNumber}</div>
                                    <div className={styles.trackingItemDetail}>
                                      <Link href={trackItem.outSiteUrl || '/'} legacyBehavior>
                                        <a rel="noopener noreferrer" className={styles.trackOrder} target={'_blank'}>Track Order</a>
                                      </Link>
                                    </div>
                                  </div>
                                ))
                                :
                                <span>{item.trackingNumber}</span>
                            }
                          </div>
                        </div>
                      ))
                    }
                  </div>
                </>
                {/* <div className={styles.emptyBox}>
                   <WishlistEmpty className={styles['empty-img']} />
                 </div> */}

              </div>
            }
          </div>
        </div>
      </DefaultLayout>
    </>

  )
}